import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

export default function LegendBar({
  colors = ["#FBE9E7", "#FAD4C0", "#F8B9A3", "#F18C7F", "#D9534F", "#A63D3D"],
  labels,
  showLevels = false,
  borderRadius = 12,

  dotSize = 10, // used in vertical mode
  rowGap = 2, // spacing between items in vertical mode
  maxHeight, // vertical list max height (enables scroll)
}) {
  const { t } = useTranslation();
  const resolvedLabels = useMemo(() => {
    if (labels && labels.length) return labels;
    return [
      t("legend.veryLow"),
      t("legend.low"),
      t("legend.moderate"),
      t("legend.high"),
      t("legend.veryHigh"),
      t("legend.extremelyHigh"),
    ];
  }, [labels, t]);

  return (
    <Box
      role="list"
      aria-label={t("legend.title")}
      sx={{
        display: "flex",
        gap: rowGap,
        maxHeight,
        overflowY: maxHeight ? "auto" : "visible",
        pr: maxHeight ? 1 : 0,
      }}
    >
      {resolvedLabels.map((label, i) => (
        <Box
          key={i}
          role="listitem"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            minHeight: Math.max(16, dotSize),
            wordBreak: "break-word",
          }}
        >
          <Box
            aria-hidden
            sx={{
              width: dotSize,
              height: dotSize,
              borderRadius: "50%",
              backgroundColor: colors[i % colors.length],
              boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.15)",
              flex: "0 0 auto",
            }}
          />
          <Typography sx={{ fontSize: 12, lineHeight: 1.25 }}>
            {showLevels ? `${i + 1}. ` : ""}
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
